// extracted by mini-css-extract-plugin
module.exports = {"rate":"style_rate__DwYGy","character":"style_character__R9rVo","checked":"style_checked__l_RnF","unChecked":"style_unChecked__yaKz1","willChecked":"style_willChecked__UDQtH"};